const isValidHex = (hexValue) =>
  /(^[0-9A-F]{6}$)|(^[0-9A-F]{3}$)/i.test(hexValue);

export default {
  isValidHex
};



// WEBPACK FOOTER //
// ./src/data/color-validator.js